import { render } from "./PartnersReportTableLoading.vue?vue&type=template&id=2c6b3deb"
import script from "./PartnersReportTableLoading.vue?vue&type=script&lang=js"
export * from "./PartnersReportTableLoading.vue?vue&type=script&lang=js"

import exportComponent from "/home/mon3m/mon3m/dafater/ManageSPA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__